import { BaseIconProps, iconDefaultProps } from "@aksara-ui/icons";
import * as React from "react";

const IconChevronStepper: React.FC<BaseIconProps> = ({
  size,
  fill,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8 16"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.02727 5.46014C1.05228 5.52098 1.09474 5.57306 1.14932 5.60981C1.20389 5.64657 1.26813 5.66636 1.33394 5.66669L6.66727 5.66669C6.73308 5.66636 6.79732 5.64657 6.85189 5.60981C6.90647 5.57306 6.94893 5.52098 6.97394 5.46014C6.99946 5.39947 7.00644 5.33261 6.99398 5.26798C6.98152 5.20335 6.95019 5.14386 6.90394 5.09702L4.23727 2.4319C4.20628 2.40067 4.16942 2.37589 4.1288 2.35897C4.08818 2.34206 4.04461 2.33335 4.00061 2.33335C3.9566 2.33335 3.91303 2.34206 3.87241 2.35897C3.83179 2.37589 3.79493 2.40067 3.76394 2.4319L1.09727 5.09702C1.05102 5.14386 1.01969 5.20335 1.00723 5.26798C0.994771 5.33261 1.00175 5.39947 1.02727 5.46014Z"
      fill={fill}
    />
    <path
      d="M6.97273 10.5399C6.94772 10.479 6.90526 10.4269 6.85068 10.3902C6.79611 10.3534 6.73187 10.3336 6.66606 10.3333H1.33273C1.26692 10.3336 1.20268 10.3534 1.14811 10.3902C1.09353 10.4269 1.05107 10.479 1.02606 10.5399C1.00054 10.6005 0.993561 10.6674 1.00602 10.732C1.01848 10.7966 1.04981 10.8561 1.09606 10.903L3.76273 13.5681C3.79372 13.5993 3.83058 13.6241 3.8712 13.641C3.91182 13.6579 3.95539 13.6666 3.9994 13.6666C4.0434 13.6666 4.08697 13.6579 4.12759 13.641C4.16821 13.6241 4.20507 13.5993 4.23606 13.5681L6.90273 10.903C6.94898 10.8561 6.98031 10.7966 6.99277 10.732C7.00523 10.6674 6.99826 10.6005 6.97273 10.5399Z"
      fill={fill}
    />
  </svg>
);

IconChevronStepper.defaultProps = {
  ...iconDefaultProps,
};

export default IconChevronStepper;
